import { useContext } from "react";

import ParamsContext from "context/params/paramsContext";
import { isClientTypeCompany } from "shared/functions";

import CompanyLevel from "./CompanyLevel";
import News from "./News";

const RightSide = () => {
    const { rootCompanyType } = useContext(ParamsContext);

    const isClientType = isClientTypeCompany(rootCompanyType);

    return (
        <>
            {isClientType && <CompanyLevel />}
            <News />
        </>
    );
};

export default RightSide;
